<div #searchSection class="scroll-section" (change)="clickSearch()">
  <!-- keyword and filter -->
  <div class="search-box">
    <div class="sub-panel">
      <div class="sub-panel-header">
        <p>検索</p>
        <app-search-action [searchService]="searchService" [searchParams]="searchParams" [showTagRegister]="false"></app-search-action>
      </div>
      <div class="condition-group">
        <div class="keyword-body">
          <textarea type="text" placeholder="テキスト検索" [(ngModel)]="this.searchParams.keyword"
          placement="right"
          (keydown)="EnterOnSearchBox($event)"></textarea>
          <button  type="button" (click)="resetSearchkeyword()"><span></span></button>
        </div>
      </div>
    </div>


    <div class="condition-group tab">
      <div class="tab-row">
        <span class="tab-cell"></span> <span class="tab-cell">不明</span><span class="tab-cell">不一致</span>
      </div>
      <div class="condition-filter tab-row" *ngFor="let filter of filters; let i = index">
        <span class="tab-cell filter-item">
          {{ filter.column | filterColumn }}
        </span>
        <div class="tab-cell">
          <label class="btn btn-primary-dark border-0 filter-btn" [class.btn-non-active]="!filter.unk">
            {{show_option(filter.unk)}}
            <input class="hide_checkbox" type="checkbox" [(ngModel)]="filter.unk" (change)="clickSearch()">
          </label>
        </div>
        <div class="tab-cell">
          <label class="btn btn-primary-dark border-0 filter-btn" [class.btn-non-active]="!filter.ng">
            {{show_option(filter.ng)}}
            <input class="hide_checkbox" type="checkbox" [(ngModel)]="filter.ng" (change)="clickSearch()">
          </label>
        </div>
      </div>
    </div>

    <div class="tag-box">
      <ng-container *ngFor="let searchTag of searchTags; let i = index">
        <app-search-tag [searchTag]="searchTag" (clickedQoalaTag)="clickedTag()">
        </app-search-tag>
      </ng-container>
    </div>

  </div>

  <div class="search-box">
      <div class="sub-panel">
        <div class="sub-panel-header" (click)="toggle('project')">
          <p>案件</p>
          <i class="fa pulldown-icon" [ngClass]="{'fa-angle-up':projectSection, 'fa-angle-down':!projectSection}" aria-hidden="true"></i>
        </div>
        <app-search-items [searchParams]="autoSearchConditionGroup.project" [page]="page" [forWorker]="false" [open]="projectSection"></app-search-items>
        <hr id="project-section" style="margin: 0;">
      </div>
  </div>
  <div class="search-box">
      <div class="sub-panel">
        <div class="sub-panel-header" (click)="toggle('worker')">
          <p>人材</p>
          <i class="fa pulldown-icon" [ngClass]="{'fa-angle-up':workerSection, 'fa-angle-down':!workerSection}" aria-hidden="true"></i>
        </div>
        <app-search-items [searchParams]="autoSearchConditionGroup.worker" [page]="page" [open]="workerSection"></app-search-items>
        <hr id="worker-section" style="margin: 0;">
      </div>
  </div>

</div>